<div class="p-2" style="scale: 0.9">
  <div class="p-2 p-md-3">
    <form
      [formGroup]="myForm"
      (ngSubmit)="onSubmit()"
      data-id="VTpwcCfJke"
      *ngIf="!isLoading; else loading"
    >
      <div class="row">
        <app-dropdown
          class="col-6"
          label="Destination"
          placeholder="Country, city, airport"
          [options]="destinations"
          [searchable]="true"
          formControlName="destinationName"
          [required]="true"
          [selectedOption]="selectedDestination"
        />
        <app-date-range-selector
          class="col-6"
          [required]="true"
          formControlName="dates"
          [customStyle]="customStyle"
        ></app-date-range-selector>
      </div>
      <div class="row">
        <app-dropdown
          class="col-6"
          label="Number of adult"
          placeholder="Number of adult"
          [options]="numberOfAdults"
          [searchable]="false"
          formControlName="numberOfAdults"
          [required]="true"
        />
        <app-dropdown
          class="col-6"
          label="Number of children"
          placeholder="Number of children"
          [options]="numberOfChildren"
          [searchable]="false"
          formControlName="numberOfChildren"
          [required]="true"
        />
      </div>
      <div class="row">
        <app-input
          [inputType]="'email'"
          label="Email"
          formControlName="email"
          [required]="true"
        />
      </div>
      <div class="row">
        <app-input
          [inputType]="'phone'"
          label="Phone"
          formControlName="contactNumber"
        />
      </div>
      <div class="row">
        <div class="col-12 col-lg-12">
          <div
            class="col-md-12 d-flex align-items-center"
            style="
              font-size: 1rem;
              color: #212529;
              gap: 10px;
              background-color: white;
              border-radius: 5px;
              padding: 5px;
              background-color: #f1f1f160;
            "
          >
            <input
              type="checkbox"
              style="display: block; height: 20px"
              [id]="uid + '-subscribe'"
              formControlName="subscribtionControl"
            /><label
              [attr.for]="uid + '-subscribe'"
              style="text-align: left"
              class="text-subscribe"
            >
              Subscribe to our newsletter for the latest news and offers</label
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button
            class="btn QuoteForm_btnQuote__Q11vV w-100 mt-2"
            style="background-color: #319197; color: #fff"
            type="submit"
          >
            Request Quote
          </button>
          <!-- Mention imposee par Google quand le badge reCAPTCHA est masque. -->
          <app-recaptcha></app-recaptcha>
        </div>
      </div>
      <div
        *ngIf="modalOpen"
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        [ngClass]="{ 'show d-block': modalOpen, fade: !modalOpen }"
        class="modal"
        style="z-index: 200000; margin-top: 50px"
        [attr.aria-hidden]="modalOpen ? null : 'true'"
        [attr.inert]="modalOpen ? null : ''"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5
                class="modal-title"
                id="staticBackdropLabel"
                style="font-size: 18px; font-weight: 600"
              >
                Request Submitted Successfully
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                (click)="closeModal()"
              ></button>
            </div>
            <div class="modal-body">
              <p>{{ successMessage }}</p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn"
                data-bs-dismiss="modal"
                (click)="closeModal()"
                style="color: #fff; background-color: #319197"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <ng-template #loading>
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </ng-template>
  </div>
</div>
